import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import getTranslation from '../../../strings/i18n';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { StyledFlex } from '../../../styles/common';
import transactionIconTypes from '../icons/transaction-type-icons';
import { StyledIconContainer, StyledIconText } from './subcomponents';
// Normalizes transactionType to match with translation file
var getTransactionTypeTranslationKey = function (transactionType) {
    if (transactionType === 'CASH_ADVANCE')
        return 'CashAdvance';
    if (transactionType === 'LATE_FEE')
        return 'LateFee';
    return (transactionType.charAt(0).toUpperCase() +
        transactionType.toLowerCase().slice(1));
};
var TransactionIcon = function (_a) {
    var badge = _a.badge, transactionType = _a.transactionType;
    var tryT = getTranslation().tryT;
    var translatedType = tryT("activity.transactionType".concat(getTransactionTypeTranslationKey(transactionType)));
    return (_jsxs(StyledFlex, { direction: "column", alignItems: "center", children: [_jsx(StyledIconContainer, { badge: badge, direction: "column", justifyContent: "center", children: transactionIconTypes[transactionType.toUpperCase()] }), _jsx(RenderIf, { condition: !badge, children: _jsx(StyledIconText, { as: "span", color: "cyanBlue", weight: "semiBold", align: "center", children: translatedType }) })] }));
};
export default TransactionIcon;
//# sourceMappingURL=index.js.map